import React, { useState, useEffect } from 'react'

// Importa las funciones de tu BL (ajusta la ruta según tu estructura)
import { ConnectWebSocketForOverlay, SetSocketMessageHandler, ClearSocketMessageHandler, DisconnectWebSocket } from './../../utilities/BL/Zones'

// Importa el componente visual hijo (el que tiene los estilos y animación)
import { SelfieFan as SelfieFanOverlay } from './Overlays/SelfieFan'


/**
 * COMPONENTE: SelfieFan OVERLAY (PARENT CONTAINER)
 * ------------------------------------------------------------------
 * Este componente es el "Cerebro" del Overlay. 
 * 1. Establece la conexión WebSocket como "overlay:selfiefan".
 * 2. Escucha los mensajes entrantes.
 * 3. Pasa la información al componente visual <SelfieFanOverlay />.
 * ------------------------------------------------------------------
 */
const SelfieFan = () => {
    
    // --- ESTADOS DE CONEXIÓN Y DATOS ---
    const [selfieFanData, setSelfieFanData] = useState(null); // Payload para el hijo
    const [overlayConfig, setOverlayConfig] = useState({ offsetX: 0, offsetY: 0, scale: 1 });
    const [connectionStatus, setConnectionStatus] = useState('idle');
    
    // -------------------------------------------------------------------------
    // EFECTO: FORZAR FONDO TRANSPARENTE
    // -------------------------------------------------------------------------
    useEffect(() => {
        const originalBodyStyle = document.body.style.backgroundColor;
        const originalHtmlStyle = document.documentElement.style.backgroundColor;
        const rootElement = document.getElementById('root'); 

        document.body.style.backgroundColor = 'transparent';
        document.documentElement.style.backgroundColor = 'transparent';
        if (rootElement) {
            rootElement.style.backgroundColor = 'transparent';
        }

        return () => {
            document.body.style.backgroundColor = originalBodyStyle;
            document.documentElement.style.backgroundColor = originalHtmlStyle;
            if (rootElement) {
                rootElement.style.removeProperty('background-color');
            }
        };
    }, []); 

    // -------------------------------------------------------------------------
    // CICLO DE VIDA: CONEXIÓN Y DESCONEXIÓN
    // -------------------------------------------------------------------------
    useEffect(() => {
        const connect = async () => {
            await ConnectWebSocketForOverlay('selfiefan', (status) => setConnectionStatus(status), (msg) => console.log(msg));
            SetSocketMessageHandler(handleIncomingMessage);
        };

        const handleIncomingMessage = (message) => {
            if (!message || !message.type) return;

            if (message.type.toLowerCase() === 'selfiefan') {
                const payloadData = message.data;
                
                // Debug temporal para que veas en consola lo que llega del backend
                //console.log("[Overlay SelfieFan] Payload recibido:", payloadData);

                // Discriminamos qué acción mandó el Admin
                if (payloadData.action === 'show') {
                    setSelfieFanData(payloadData); // Guardamos la imagen
                } else if (payloadData.action === 'hide') {
                    setSelfieFanData(null); // Borramos la imagen
                } else if (payloadData.action === 'config') {
                    // Actualizamos posiciones sin borrar la imagen actual
                    setOverlayConfig({
                        offsetX: payloadData.offsetX,
                        offsetY: payloadData.offsetY,
                        scale: payloadData.scale
                    });
                } else if (payloadData.action === 'show_qr') {
                    // NUEVO: Atrapamos la acción del QR y se la pasamos al hijo
                    setSelfieFanData(payloadData); 
                }
            }
        };

        connect();
        return () => { ClearSocketMessageHandler(); DisconnectWebSocket(); };
    }, []);

    // -------------------------------------------------------------------------
    // RENDERIZADO
    // -------------------------------------------------------------------------
    return (
        <>
            {/* Renderizamos el componente visual pasándole la data del socket. */}
            <SelfieFanOverlay data={selfieFanData} config={overlayConfig} /> 

            {/* Indicador de error de conexión (útil para debug en OBS) */}
            {connectionStatus === 'error' && (
                <div style={{ position: 'fixed', bottom: 0, right: 0, background: 'red', color: 'white', padding: 5, fontSize: 10, zIndex: 9999 }}>D</div>
            )}
        </>
    );
};

export { SelfieFan };









// import React, { useState, useEffect } from 'react'

// // Importa las funciones de tu BL (ajusta la ruta según tu estructura)
// import { ConnectWebSocketForOverlay, SetSocketMessageHandler, ClearSocketMessageHandler, DisconnectWebSocket } from './../../utilities/BL/Zones'

// // Importa el componente visual hijo (el que tiene los estilos y animación)
// import { SelfieFan as SelfieFanOverlay } from './Overlays/SelfieFan'


// /**
//  * COMPONENTE: SelfieFan OVERLAY (PARENT CONTAINER)
//  * ------------------------------------------------------------------
//  * Este componente es el "Cerebro" del Overlay. 
//  * 1. Establece la conexión WebSocket como "overlay:selfiefan".
//  * 2. Escucha los mensajes entrantes.
//  * 3. Pasa la información al componente visual <SelfieFanOverlay />.
//  * ------------------------------------------------------------------
//  */
// const SelfieFan = () => {
    
//     // --- ESTADOS DE CONEXIÓN Y DATOS ---
//     const [selfieFanData, setSelfieFanData] = useState(null); // Payload para el hijo
//     // NUEVO: Estado separado para la configuración visual (Inicia en los valores por defecto)
//     const [overlayConfig, setOverlayConfig] = useState({ offsetX: 0, offsetY: 0, scale: 1 });
//     const [connectionStatus, setConnectionStatus] = useState('idle');
    
//     // -------------------------------------------------------------------------
//     // EFECTO: FORZAR FONDO TRANSPARENTE
//     // -------------------------------------------------------------------------
//     useEffect(() => {
//         // 1. Guardamos el color original por si acaso (buena práctica)
//         const originalBodyStyle = document.body.style.backgroundColor;
//         const originalHtmlStyle = document.documentElement.style.backgroundColor;
//         const rootElement = document.getElementById('root'); // El contenedor de React

//         // 2. Aplicamos la transparencia "a la fuerza"
//         document.body.style.backgroundColor = 'transparent';
//         document.documentElement.style.backgroundColor = 'transparent';
//         if (rootElement) {
//             rootElement.style.backgroundColor = 'transparent';
//         }

//         // 3. Cleanup: Cuando este componente se desmonte (cambies de pantalla),
//         // restauramos el color original (o lo dejamos vacío para que tome el CSS).
//         return () => {
//             document.body.style.backgroundColor = originalBodyStyle;
//             document.documentElement.style.backgroundColor = originalHtmlStyle;
//             if (rootElement) {
//                 rootElement.style.removeProperty('background-color');
//             }
//         };
//     }, []); // El array vacío asegura que esto corra solo al montar y desmontar

//     // Opcional: Si necesitas manejar el modo femenil/varonil aquí también
//     // const [isActiveWomensMode, setIsActiveWomensMode] = useState(false); 

//     // -------------------------------------------------------------------------
//     // CICLO DE VIDA: CONEXIÓN Y DESCONEXIÓN
//     // -------------------------------------------------------------------------
//     useEffect(() => {
//         const connect = async () => {
//             await ConnectWebSocketForOverlay('selfiefan', (status) => setConnectionStatus(status), (msg) => console.log(msg));
//             SetSocketMessageHandler(handleIncomingMessage);
//         };

//         const handleIncomingMessage = (message) => {
//             if (!message || !message.type) return;

//             if (message.type.toLowerCase() === 'selfiefan') {
//                 const payloadData = message.data;

//                 // Discriminamos qué acción mandó el Admin
//                 if (payloadData.action === 'show') {
//                     setSelfieFanData(payloadData); // Guardamos la imagen
//                 } else if (payloadData.action === 'hide') {
//                     setSelfieFanData(null); // Borramos la imagen
//                 } else if (payloadData.action === 'config') {
//                     // Actualizamos posiciones sin borrar la imagen
//                     setOverlayConfig({
//                         offsetX: payloadData.offsetX,
//                         offsetY: payloadData.offsetY,
//                         scale: payloadData.scale
//                     });
//                 }
//             }
//         };

//         connect();
//         return () => { ClearSocketMessageHandler(); DisconnectWebSocket(); };
//     }, []);

//     // -------------------------------------------------------------------------
//     // RENDERIZADO
//     // -------------------------------------------------------------------------
//     return (
//         <>
//             {/* Renderizamos el componente visual pasándole la data del socket.
//                 Si tuvieras lógica de Modo Femenil, pásala aquí también.
//             */}
//             <SelfieFanOverlay data={selfieFanData} config={overlayConfig} /> {/* isActiveWomensMode={isActiveWomensMode} */}

//             {/* Opcional: Indicador de error de conexión (útil para debug en OBS) */}
//             {connectionStatus === 'error' && (
//                 <div style={{ position: 'fixed', bottom: 0, right: 0, background: 'red', color: 'white', padding: 5, fontSize: 10 }}>D</div>
//             )}
//         </>
//     );
// };

// export { SelfieFan };